interface BackupCodesNoticeProps {
  codes: ReadonlyArray<string>;
  title?: string;
  description?: string;
}

/**
 * 평문 백업 코드 1회 노출 패널. enroll·regenerate 응답에서만 받은 코드를 보여주며,
 * 이 화면을 벗어나면 다시 확인할 수 없음을 안내한다. UUID 가 아닌 운영자용 1회용 코드라
 * 노출이 의도된 값이다.
 */
export const BackupCodesNotice = ({
  codes,
  title = '백업 코드',
  description = '인증 앱을 사용할 수 없을 때 사용하는 1회용 코드입니다. 안전한 곳에 보관하세요. 이 코드는 지금만 표시되며 다시 확인할 수 없습니다.',
}: BackupCodesNoticeProps) => {
  if (codes.length === 0) return null;
  return (
    <div
      className="flex flex-col gap-2 rounded-md p-4"
      style={{
        background: 'var(--surface-0)',
        border: '1px solid var(--divider-strong)',
      }}
      data-testid="two-factor-backup-codes"
    >
      <span className="text-sm font-semibold" style={{ color: 'var(--content-strong)' }}>
        {title}
      </span>
      <p className="text-xs" style={{ color: 'var(--content-muted)' }}>
        {description}
      </p>
      <ul className="mt-1 grid grid-cols-2 gap-1.5">
        {codes.map((code) => (
          <li
            key={code}
            className="rounded px-2 py-1 text-center text-sm font-mono tabular-nums tracking-widest"
            style={{
              background: 'var(--surface-1)',
              border: '1px solid var(--divider-soft)',
              color: 'var(--content-strong)',
            }}
          >
            {code}
          </li>
        ))}
      </ul>
    </div>
  );
};
